/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Angles',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Rechercher des annonces, des ressources et des politiques vérifiées',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filtres',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Texte fictif',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    "Personnalisez l'invite que vos lecteurs verront",
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Ajouter une barre de recherche filtrée',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Arrondi',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Carré',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Couleur de remplissage',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Couleur du texte',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Styles',
  'company-hub.search-extension.custom-search-config-panel.title': 'Recherche personnalisée',
  'company-hub.search-extension.manifest.default-placeholder-text':
    'Rechercher des annonces, des ressources et des politiques vérifiées',
  'company-hub.search-extension.manifest.macro-description': 'Ajouter une barre de recherche filtrée',
  'company-hub.search-extension.manifest.macro-title': 'Recherche personnalisée',
  'company-hub.search-extension.more-button': 'Afficher plus de résultats',
};
